import React from 'react'
import './buttons.css'

const ButtonGroupGrayCustom = ({ options }) => {
    return (
        <div className='d-flex gap-2 flex-wrap'>
            {
                options.map((option, idx) =>
                    <button
                        key={idx}
                        className={`btn btn-group-gray ${option.active ? 'btn-group-gray-active' : ''}`}
                        onClick={option.onClick}
                    >
                        {option.title}
                    </button>
                )
            }
        </div>
    )
}

export default ButtonGroupGrayCustom